import { fbt } from 'fbtee'
import { SeparatorHorizontal } from 'lucide-react'
import { OptionChip } from '../../../components/OptionChip'

export function AddMarkerButton({ onClick }: { onClick: () => void }) {
  return (
    <OptionChip
      icon={<SeparatorHorizontal className="size-5" />}
      label={fbt('Add line', 'Schedule chip label to add a custom labeled line to the schedule')}
      title={fbt('Add a line to your schedule: dinner, meet up, back to camp…', 'Tooltip on the schedule chip that adds a custom line')}
      onClick={onClick}
      testId="schedule-add-marker"
    />
  )
}
